
























































































import { computed, defineComponent, watch, toRefs, Ref } from '@vue/composition-api';
import placementType from './index';
import { PropType } from 'vue';
import { xorBy, isEqual } from 'lodash-es';
import {
  FlowType,
  InventoryFlow,
  SearchAdsSwitch,
  AdgroupFormData,
  CampaignFormData,
  AdgroupConfig,
  Ios14Quota,
  CreateMode,
} from '@tt4b/ttam-enums';
import { useAdgroupPlacementValidate, useStdAdgroupAmazon, useAdgroupMode, useStdAdgroupIs } from '@tt4b/ttam-hooks';
import { trackEvent } from './../../../utils/index';
import TtamTipBox from '@/components/common/tip-box/index.vue';
import ALink from '@/components/common/a-link/a-link.vue';
import { GetVSAInventoryFlowTypesItem } from './consts';

const name = 'ttam-placement-type-compose';
export default defineComponent({
  name,
  components: {
    // TtamPlacementTypeTips: placementType.TtamPlacementTypeTips,
    // TtamPlacementTypeLabel: placementType.TtamPlacementTypeLabel,
    // TtamPlacementTypeLabelHint: placementType.TtamPlacementTypeLabelHint,
    TtamPlacementTypeFlowTypeOptions: placementType.TtamPlacementTypeFlowTypeOptions,
    TtamPlacementTypeTiktokItem: placementType.TtamPlacementTypeTiktokItem,
    TtamPlacementTypeInventoryflowList: placementType.TtamPlacementTypeInventoryflowList,
    TtamPlacementTypeVsaAutoItem: placementType.TtamPlacementTypeVsaAutoItem,
    TtamTipBox,
    ALink,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      required: true,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      required: true,
      default: () => ({}),
    },
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      required: true,
      default: () => ({}),
    },
    ios14QuotaInfo: {
      type: Object as PropType<Ios14Quota>,
      required: false,
      default: () => ({}),
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
    isSupportPangleWithVSA: {
      type: Boolean,
      default: true,
    },
  },
  // eslint-disable-next-line max-lines-per-function
  setup(props, { emit }) {
    const { adgroupData, campaignData, adgroupConfig, ios14QuotaInfo, createMode, isSupportPangleWithVSA } =
      toRefs(props);
    const _searchDeliveryType = computed({
      get: () => props.adgroupData?.searchDeliveryType,
      set: val => {
        emit('search-delivery-type-change', val);
      },
    });

    const _inventoryFlow = computed({
      get: () => props.adgroupData?.inventoryFlow,
      set: val => {
        emit('inventory-flow-change', val);
      },
    });

    const { isEdit, isCreate } = useAdgroupMode({ createMode });
    const { isLiveAds, isStandardAdsWithShop, isStandardAdsWithShowcase, isProductSalesCloseLoopVSAWithPangle } =
      useStdAdgroupIs({
        campaignFormData: campaignData,
        adgroupFormData: adgroupData,
      });
    const isShowPlacementTipsForOnlyTT = computed(
      () => isLiveAds.value || isStandardAdsWithShop.value || isStandardAdsWithShowcase.value,
    );
    const { list: inventoryFlows, hasDisabledPlacement } = placementType.useInventoryListPropsList({
      adgroupData,
      campaignData,
      adgroupConfig,
      ios14QuotaInfo: ios14QuotaInfo as Ref<Ios14Quota>,
      createMode,
    });
    const { visible: isShowInventoryTips, tipsContent } = placementType.useInventoryTipsPropsVisible({
      adgroupData,
      campaignData,
      ios14QuotaInfo: ios14QuotaInfo as Ref<Ios14Quota>,
      isEdit,
    });

    const _inventoryFlowType = computed({
      get: () => props.adgroupData?.inventoryFlowType || FlowType.AUTO,
      set: val => {
        if (isEqual(val, _inventoryFlowType.value)) {
          return;
        }
        emit('inventory-flow-type-change', val);
      },
    });

    const { disabled: inventoryFlowDisabled } = placementType.useInventoryFlowListPropsDisabled({
      adgroupConfig,
    });

    const { disabled: inventoryFlowTypeDisabled } = placementType.useFlowTypeOptionsPropsDisabled({
      adgroupConfig,
      hasDisabledPlacement,
    });
    const { list: inventoryTypeOptions } = placementType.useInventoryTypeListPropsList(hasDisabledPlacement);

    const { visible: isOnlySupportTT } = placementType.useTiktokItemPropsVisible({
      campaignData,
      adgroupData,
      createMode,
    });

    const { tips: placementOnlyTiktokTips } = placementType.usePlacementOnlyTikTokTips({
      campaignData,
      adgroupData,
    });

    const { visible: searchDeliveryTypeVisible } = placementType.useSearchDeliveryTypeSwitchPropsVisible({
      campaignData,
    });

    const { disabled: searchDeliveryTypeDisabled } = placementType.useSearchDeliveryTypeSwitchPropsDisabled({
      adgroupData,
      campaignData,
      adgroupConfig,
      createMode,
    });

    // const { showTips } = placementType.usePropsShowTips({
    //   adgroupData,
    //   adgroupConfig,
    //   campaignData,
    //   inventoryFlows,
    // });

    // const { visible: labelHintVisible } = placementType.useLabelHintPropsVisible({
    //   campaignData,
    // });

    const { isAmazonAppinstall } = useStdAdgroupAmazon({
      campaignFormData: campaignData,
    });

    const { inventoryFlowValidator } = useAdgroupPlacementValidate();

    const onInventoryFlowTypeChange = (v: number) => {
      _inventoryFlowType.value = v;
    };

    const onInventoryFlowChange = (v: InventoryFlow[]) => {
      if (xorBy(v, _inventoryFlow.value).includes(InventoryFlow.TIKTOK)) {
        if (searchDeliveryTypeVisible.value && v.includes(InventoryFlow.TIKTOK)) {
          _searchDeliveryType.value = SearchAdsSwitch.OPEN;
        } else {
          _searchDeliveryType.value = SearchAdsSwitch.CLOSE;
        }
      }
      _inventoryFlow.value = v;
    };

    const onSearchDeliverlyTypeChange = (v: number) => {
      _searchDeliveryType.value = v;
    };

    // 如果版位存在被禁用的场景，需要更换成select
    watch(
      hasDisabledPlacement,
      () => {
        if (!isCreate.value) {
          return;
        }
        if (_inventoryFlowType.value === FlowType.AUTO && hasDisabledPlacement.value) {
          _inventoryFlowType.value = FlowType.SELECTED;
        } else if (_inventoryFlowType.value === FlowType.SELECTED && hasDisabledPlacement.value) {
          _inventoryFlow.value = inventoryFlows.value?.filter(o => !o.quotaDisabled).map(o => o.id);
        }
      },
      {
        immediate: true,
      },
    );
    watch(
      searchDeliveryTypeVisible,
      () => {
        if (searchDeliveryTypeVisible.value && _inventoryFlow.value?.includes(InventoryFlow.TIKTOK)) {
          _searchDeliveryType.value = SearchAdsSwitch.OPEN;
        } else {
          _searchDeliveryType.value = SearchAdsSwitch.CLOSE;
        }
      },
      {
        immediate: true,
      },
    );

    // onMounted(() => {
    //   console.log('123232', searchDeliveryTypeVisible.value);
    //   if (searchDeliveryTypeVisible.value) {
    //     _searchDeliveryType.value = SearchAdsSwitch.OPEN;
    //   } else {
    //     _searchDeliveryType.value = SearchAdsSwitch.CLOSE;
    //   }
    // });

    const isManualSelect = computed(
      () =>
        !isOnlySupportTT.value &&
        _inventoryFlowType.value === FlowType.SELECTED &&
        !isProductSalesCloseLoopVSAWithPangle.value,
    );

    const onLearnMoreClick = () => {
      trackEvent('create_adgroup_placement_pangle_learnMore');
      window.open('/help/article?aid=9587', '_blank');
    };

    const iconHoverTrack = () => trackEvent('create_adgroup_placement_hover');

    const vsaInventoryFlowTypesItem = computed(() => GetVSAInventoryFlowTypesItem(isSupportPangleWithVSA.value));

    return {
      name,
      inventoryFlows,
      inventoryFlowDisabled,
      inventoryFlowTypeDisabled,
      inventoryFlowValidator,
      isOnlySupportTT,
      // showTips,
      // labelHintVisible,
      _inventoryFlowType,
      _searchDeliveryType,
      _inventoryFlow,
      isManualSelect,
      isAmazonAppinstall,
      searchDeliveryTypeVisible,
      searchDeliveryTypeDisabled,
      hasDisabledPlacement,
      inventoryTypeOptions,
      isShowInventoryTips,
      tipsContent,
      isShowPlacementTipsForOnlyTT,
      placementOnlyTiktokTips,
      isProductSalesCloseLoopVSAWithPangle,
      vsaInventoryFlowTypesItem,
      onInventoryFlowTypeChange,
      onInventoryFlowChange,
      onSearchDeliverlyTypeChange,
      onLearnMoreClick,
      iconHoverTrack,
    };
  },
});
